// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2gv22","label":"styles_label__1WBHu"};